import { API_DEV } from "constants/api";

import { header, handleAPIResult, serialize, formatMaterialFilters } from "utils";

export const documentService = {
  list,
  gallery,
  last,
  get,
  create,
  remove,
  powerBiUrl,
};

function last(number = 10, filters = {}) {
  const getInfo = {
    method: "GET",
    headers: header(),
  };

  var params = new URLSearchParams({ number });
  Object.entries(filters).forEach(([k, v]) => { if (v) params.append(k, v); });
  var qs = params.toString();

  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/documents/last?" + qs, getInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function list(filters = {}, material = {}) {
  const getInfo = {
    method: "GET",
    headers: header(),
  };

  var qs =
    Object.keys(material).length === 0
      ? serialize(filters)
      : formatMaterialFilters(filters, material);
  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/documents?" + qs, getInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function gallery(filters = {}, page_number, per_page, order_by, order_direction) {
  const getInfo = {
    method: "GET",
    headers: header(),
  };

  let qs = [
    (page_number && per_page && serialize({ page_number, per_page })) || "",
    order_by && serialize({ order_by }),
    order_direction && serialize({ order_direction }),
  ]
    .filter((q) => !!q)
    .join("&");

  return new Promise((resolve, reject) => {
    fetch(API_DEV + `/${filters.type || "projects"}/gallery/${filters.id || ""}?${qs}`, getInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function get(id) {
  const getInfo = {
    method: "GET",
    headers: header(),
  };

  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/documents/" + id, getInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.blob();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function create(document) {
  const generateFD = (doc) => {
    var formData = new FormData();
    formData.append("document[model]", doc.model);
    formData.append("document[target_id]", doc.target_id);
    formData.append("document[type_id]", doc.type_id);
    formData.append("document[url]", doc.url);
    formData.append("document[label]", doc.label);
    formData.append("document[filename]", doc.url.name);
    formData.append("document[extension]", doc.url.type);

    return formData;
  };

  const submitDoc = (doc) => {
    const postInfo = {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        ...header(),
      },

      body: generateFD(doc),
    };

    delete postInfo.headers["Content-Type"];

    return new Promise((resolve, reject) => {
      fetch(API_DEV + "/documents", postInfo)
        .then((result) => {
          handleAPIResult(result, reject);
          return result.json();
        })
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  if ("urls" in document) {
    var promises = [];
    for (var i = 0; i < document.urls.length; i++) {
      var doc = { ...document, url: document.urls[i] };
      promises.push(submitDoc(doc));
    }

    return Promise.all(promises);
  } else {
    return submitDoc(document);
  }
}

function remove(document) {
  const getInfo = {
    method: "DELETE",
    headers: header(),
  };

  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/documents/" + document.id, getInfo)
      .then((result) => {
        handleAPIResult(result, reject, 204);
        return true;
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//Retourne l'url pour power bi
function powerBiUrl() {
  return API_DEV + "/documents";
}
